<template>
  <div class="SectionAchievedTargetReviewCarousel">
    <ReviewCarouselTabs :reviews="reviews" />
  </div>
</template>

<script setup lang="ts">
import ReviewCarouselTabs from '@/views/components/misc/ReviewCarouselTabs.vue'
import { type ReviewCarouselItem } from '@/views/components/misc/reviewCarousel.shared'

const reviews: ReviewCarouselItem[] = [
  {
    rating: 5,
    name: 'Klaudia Kiones',
    jobTitle: 'Group Sustainability Manager',
    companyLogoKey: 'epsog',
    logoHeight: 22,
    text: `Sustainalyse helped  EPSO-G come a long way – from calculating the group's GHG emissions in all areas to setting clear short-term GHG targets to modeling the logic of a zero GHG emissions balance with integrated data calculation solutions. We appreciate the constructive cooperation, flexibility, and professionalism. We highly recommend them to those who do not know where to start when setting GHG emission reduction targets of their company.`,
    size: 'xl',
  },
  {
    rating: 5,
    name: 'Migle Skodiene',
    jobTitle: 'Head of Sustainability and Innovations',
    companyLogoKey: 'agrokoncernas',
    logoHeight: 24,
    text: 'The Sustainalyse software exceeded our expectations. It is highly user-friendly, logically structured, and perfectly suited to both initial data collection and more detailed emissions analysis.',
    size: 'xl',
  },
]
</script>

<style scoped lang="scss">
.SectionAchievedTargetReviewCarousel {
  width: 100%;
}
</style>
